let recaptchaLoaderPromise = null

// Loads Google's reCAPTCHA v3 script once and resolves with `grecaptcha` when it is ready.
export function loadRecaptcha (scriptUrl, siteKey) {
  if (window.grecaptcha?.execute) return ready(window.grecaptcha)

  if (recaptchaLoaderPromise) return recaptchaLoaderPromise

  recaptchaLoaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = `${scriptUrl}?${new URLSearchParams({ render: siteKey }).toString()}`
    script.async = true
    script.onload = () => ready(window.grecaptcha).then(resolve, reject)
    script.onerror = () => {
      recaptchaLoaderPromise = null
      script.remove()
      reject(new Error("Failed to load reCAPTCHA"))
    }
    document.head.appendChild(script)
  })

  return recaptchaLoaderPromise
}

function ready (grecaptcha) {
  if (!grecaptcha?.ready) return Promise.reject(new Error("reCAPTCHA unavailable"))

  return new Promise((resolve) => grecaptcha.ready(() => resolve(grecaptcha)))
}
